<template>
  <div class="container">
    <h1 class="title is-3">Contact</h1>
    <p>Loop je tegen een probleem aan of heb je een vraag? Neem dan contact op met Ikleeralles.nl</p>
    <br />
    <b-field label="E-mail">
      <b-input v-model="email"></b-input>
    </b-field>
    <b-field label="Bericht">
      <b-input v-model="message" type="textarea"></b-input>
    </b-field>
    <b-button @click="send()">Versturen</b-button>
  </div>
</template>
<script>
import ApiService from "@/common/api.service";
import router from "@/router";
import moment from "moment";

export default {
  props: ["id"],
  data() {
    return {
      email: "",
      message: ""
    };
  },
  mounted() {
    this.getEmail();
  },
  methods: {
    async getEmail() {
      let response = await ApiService.get("user");
      if (response) {
        this.email = response.data.email
      }
    },
    async send() {
      let response = await ApiService.post("contact", {
        email: this.email,
        message: this.message
      }, true, false)
      this.$buefy.toast.open({
        message: "Bedankt voor je bericht!",
        type: "is-success"
      })
      return router.push('/dashboard')
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 20px;
}
</style>
